import React, {useState} from "react";
import tw from "twin.macro";
import {Link} from 'react-router-dom';

import styled from "styled-components";
import {Container} from "components/misc/Layouts";
import {SectionHeading} from "components/misc/Headings";
import Footer from "components/Footer";
import Hero from "components/headers/light";
import MovieCard from "components/MovieCard";

import {ReactComponent as StarIcon} from "feather-icons/dist/icons/star.svg";
import {ReactComponent as ReelIcon} from "../../images/flximg/reel.svg";
import AdComponent from '../../components/AdComponent.js';

const ButtonContainer = tw.div``;
const LoadMoreButton = tw.text` text-gray-700 font-semibold mx-auto text-sm rounded-sm`;
const Heading = tw.text`lg:text-2xl md:text-xl font-bold  text-gray-900`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl p-2 w-full mx-auto`;
const One = tw.div` flex overflow-x-auto `;
const Div = tw.div`flex justify-between items-center`;



const Content = tw.div`mt-1 lg:mx-2 lg:mt-2 `;
const TextInfo = tw.div` flex justify-center px-2 py-1 md:p-0 bg-yellow-50`;
const TitleReviewContainer = tw.div``;
const Title = tw.h5`md:text-sm text-xs lg:text-lg font-semibold`;
const Rating = tw.span`md:text-sm text-xxs lg:text-lg ml-2 my-auto text-gray-900 lg:font-semibold`;
const Year = tw.div`md:text-xs text-xxs  text-yellow-800`;

const YearInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`w-5 h-5 text-yellow-500 fill-current`}
  }
`;

const RatingsInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`lg:w-5 lg:h-5 md:w-3 md:h-3 w-2 h-2  text-yellow-500 fill-current`}
  }
`;

const CardImage = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`lg:h-56 lg:w-40 md:h-56 md:w-40 h-40 w-24 mr-2 bg-cover bg-center rounded`,
]);

function HomeActressImage({headingText, actress}) {
  return (
    <Container>
      {/* <AdComponent/>  */}
      <ContentWithPaddingXl>
        <Div >
          <Heading>{headingText}</Heading>
          {actress < 8 ? null : <ButtonContainer>
            <Link to="/actors">
              <LoadMoreButton>Read More</LoadMoreButton>
            </Link>
          </ButtonContainer>}
        </Div>


        <One>
          {actress.map((item) => (
            <Link to={`/actress/${item.id}`}>
              <Content>
                <CardImage imageSrc={item.cover_url} >
                </CardImage>
                <TextInfo>
                  <Title><Link to={`/trendingMovies/${item.id}`}>{item.title}</Link></Title>
                </TextInfo>
              </Content>
            </Link>

          ))}
        </One>


      </ContentWithPaddingXl>
    </Container>
  )
}

export default HomeActressImage